import { KeyRound, Compass, Palmtree } from "lucide-react";
import { ChapterHeading, Reveal } from "./Reveal";

const CARDS = [
  {
    icon: KeyRound,
    title: "Personal floor-plan walkthrough",
    body: "Kali'u has ten residence types across two collections, priced from $890,000. Join the list and I'll walk you through every plan on a 15-minute call — which stacks, which views, which layouts fit how you actually live.",
  },
  {
    icon: Compass,
    title: "Independent representation",
    body: "I represent you, not the developer. Candid advice on value, deposits, and timing — at no cost to you as a buyer.",
  },
  {
    icon: Palmtree,
    title: "Local Oahu perspective",
    body: "On-island knowledge of Ala Moana and Kaka'ako — what boutique living here is really like, season to season.",
  },
];

const WhyJoin = () => (
  <section className="py-24 md:py-32" data-testid="why-join-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <ChapterHeading
        number="01"
        overline="Why Work With Marlene"
        title="Someone reading the fine print for you."
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-line border border-line mt-14 md:mt-20" data-testid="benefit-cards">
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12} className="bg-ivory">
            <div className="p-8 md:p-10 h-full group hover:bg-sand transition-colors duration-700" data-testid={`benefit-card-${i}`}>
              <c.icon size={22} strokeWidth={1.25} className="text-teal" />
              <h3 className="font-serif text-xl md:text-2xl font-light text-charcoal mt-6 leading-snug">{c.title}</h3>
              <p className="text-sm text-stone2 leading-relaxed mt-4">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p className="mt-10 text-xs tracking-wide text-stone2 max-w-2xl leading-relaxed">
          No obligation. Just a straight-talking buyer&rsquo;s agent in your corner.
        </p>
      </Reveal>
    </div>
  </section>
);

export default WhyJoin;

